// Copyright (C) 2017-2022 Smart code 203358507

const Addon = require('./Addon');

module.exports = Addon;
